import { onSnapshot, query, orderBy, where } from "firebase/firestore";
import React, { useEffect, useState, useContext } from "react";
import { customersRef } from "../firebase";
import { AuthContext } from "../providers/AuthProvider";

const CustomersContext = React.createContext([]);

const CustomersProvider = (props) => {
  const [customers, setCustomers] = useState([]);
  const { userData } = useContext(AuthContext);

  useEffect(() => {
    if (!userData.uid) {
      return;
    }

    const q = query(
      customersRef,
      orderBy("name", "asc"),
      where("createdBy", "in", userData.associatedAccounts)
    );
    const unSubFromCustomers = onSnapshot(q, (querySnapshot) => {
      const dbCustomers = [];
      querySnapshot.forEach((customer) => {
        if (customer.data().name === "Private") {
          //Put Private at the top of the list.
          dbCustomers.unshift(customer.data());
        } else {
          //Otherwise put at end, will be in alphabetical order
          dbCustomers.push(customer.data());
        }
      });
      setCustomers(dbCustomers);
    });

    return () => {
      unSubFromCustomers();
    };
  }, [userData.associatedAccounts, userData.uid]);

  return (
    <CustomersContext.Provider value={customers}>
      {props.children}
    </CustomersContext.Provider>
  );
};

export { CustomersProvider, CustomersContext };
